/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldKazakh = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1477 1536h251v512h-320v-256h-225l-494-723q-14-21-24-45t-21-47h-6v815H256V128h382v787h6q9-23 21-48t26-45l469-694h455l-591 794 453 614z"
    }));
export default SvgBoldKazakh;
